import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { selectVfaAdvancedMetricsEnabled } from "@store/userPreferences/userPreferencesSlice";
import {
  VFA_ADVANCED_METRICS_QUERY_FLAG,
  isVfaAdvancedMetricsVisible,
} from "@utils/VFA/advancedMetricsScope";

export function useVfaAdvancedMetricsVisible(
  test: { orgScope?: string[] } | null | undefined,
): boolean {
  const enabledByUser = useSelector(selectVfaAdvancedMetricsEnabled);
  const [searchParams] = useSearchParams();
  return isVfaAdvancedMetricsVisible(
    test,
    enabledByUser,
    searchParams.get(VFA_ADVANCED_METRICS_QUERY_FLAG),
  );
}
